import React from 'react';
import {chunk} from './utils'

const ServiceDetailItemsList = ({ group }) => (
  <ul>
    {group.map(item => {
      return <li key={item}>{item}</li>
    })}
  </ul>
);

const ServiceDetailItems = ({ items }) => (
  <div className="row">
    {chunk(items).map(group => {
      return <div key={group} className="col">
        <ServiceDetailItemsList group={group}/>
      </div>
    })}
  </div>
);

const ServiceDetails = ({ services }) => (
  <div>
    {services.map(service => {
      return (
        <div key={service.text}>
          <h5>
            <i className={'fa ' + service.icon}></i> {service.full_text || service.text}
          </h5>
          <p dangerouslySetInnerHTML={{ __html: service.description }}></p>
          {service.items && service.items.length &&
            <ServiceDetailItems items={service.items}/>
          }
          {service.secondary && 
            <p className="text-right">
              <small>
                <i dangerouslySetInnerHTML={{ __html: service.secondary }}></i>
              </small>
            </p>
          }
        </div>
        );
      }
    )}
  </div>
);

export default ServiceDetails;


// WEBPACK FOOTER //
// ./src/components/ServiceDetails.js